import { render } from "./Pill.vue?vue&type=template&id=f54bf48c&scoped=true"
import script from "./Pill.vue?vue&type=script&lang=js"
export * from "./Pill.vue?vue&type=script&lang=js"

import "./Pill.vue?vue&type=style&index=0&id=f54bf48c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f54bf48c"]])

export default __exports__